import type { ChatMessage } from '../types/chat-message.js';
import type { ThreadApiMessage } from '../types/thread-api.js';
import type { MessageAttachment } from '../rich-media/types.js';

/** Whether a mapped chat row has anything to render in the bubble. */
export function isChatMessageDisplayable(message: ChatMessage): boolean {
  if (message.isTypingPlaceholder) return false;

  if (message.attachment?.url) return true;
  if (message.mediaUrl?.trim()) return true;
  if (message.text.trim()) return true;
  if (message.linkPreviews && message.linkPreviews.length > 0) return true;

  return false;
}

export function isThreadApiMessageDisplayable(
  message: ThreadApiMessage,
  text: string,
  attachment: MessageAttachment | null | undefined,
): boolean {
  if (attachment?.url) return true;
  if (text.trim()) return true;
  if (message.message?.trim()) return true;
  if (message.raw_message?.payload?.trim()) return true;
  if (message.type === 2 && message.message?.trim()) return true;
  return false;
}
